import React from "react"
import RegularButton from "components/CustomButtons/Button";
import {formatterNumberDecimals} from 'helpers/mathDictionary';
//redux
import { useDispatch } from "react-redux"
import { getStations,editPrice, getStationsUpdate } from "redux/actions/integrations/itemsActions";
//Mui icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import ShareIcon from '@mui/icons-material/Share';


const colors = {
    success: '#4caf50',
    error: '#f6685e',
    info: '#4092E5'
  }

export const columns = [
    {
        "Header": "Id",
        "accessor": "itemNumber",
        "filterable": true,
        "filterMethod": (filter, row) => {  return row.itemNumber?.toLowerCase().includes(filter.value.toLowerCase());}
    },
    {
        "Header": "Sugerencias",
        "accessor": "itemDescription",
        "filterable": true,
        "filterMethod": (filter, row) => {  return row.itemDescription?.toLowerCase().includes(filter.value.toLowerCase());}
    },
    {
        "Header": "Acciones",
        Cell: ({ original }) => {
            const dispatch = useDispatch()
            const handleNav = () => {
                dispatch( getStations(original.itemNumber) )
            }
            const handleNavEdit = () => {
                dispatch( getStationsUpdate(original.itemNumber))
                dispatch( editPrice() )
            }

            return (
                <>
                    <RegularButton
                        color="transparent"
                        round
                        justIcon
                        onClick={ handleNav }
                        tooltip="Ver Plantas"
                        style={{
                            float: 'right'
                        }}
                    >
                        <VisibilityIcon style={{margin: 0, color: colors.info}}/>
                    </RegularButton>
                    <RegularButton
                        color="transparent"
                        round
                        justIcon
                        onClick={ handleNavEdit }
                        tooltip="Actualizar artículo"
                        style={{
                            float: 'right'
                        }}
                    >
                        <ShareIcon style={{margin: 0, color: colors.info}}/>
                    </RegularButton>
                </>
                
            )
        }
    }]

export const columnsStations = [
    {
        "Header": "Plantas",
        "accessor": "stationName",
        "filterable": true,
        "filterMethod": (filter, row) => {  return row.stationName?.toLowerCase().includes(filter.value.toLowerCase());}
    },
    {
        "Header": "Precio de lista",
        "accessor": "listPrice",
        Cell: props => props.value != null ? '$'+ formatterNumberDecimals(props.value, 2) : null
    },
    {
        "Header": "Acciones",
        Cell: ({ original }) => {
            const dispatch = useDispatch()
            const handleNav = () => {
                dispatch( editPrice({value:original.station, label: original.stationName, oraclePrice: original?.listPrice}) )
            }
            
            return (
                <>
                    <RegularButton 
                        color="transparent" 
                        round 
                        onClick={handleNav}
                        justIcon
                        tooltip="Editar precio"
                        style={{
                            float: 'right'
                        }}>
                        <EditIcon color="primary" />
                    </RegularButton>
                </>
                
            )
        }
    }]